/* eslint-disable */
import ScrollMagic from 'scrollmagic';

var scrollAutoplayHandler = function() {
	var $el = $(this);
	var video = $el.children('video').get(0);
	video.play();
}

var playFromTimestamp = function(timestamp, videoplayer) {
	videoplayer.pause();
	videoplayer.currentTime = timestamp;
	videoplayer.play();
}

var activeBtn = function($btn) {
	$('.js-timestampbtn').removeClass('is-active');
	$btn.addClass('is-active');
}

export default {
  init() {
    if ( $('.js-sequencedvideo').length ) {


		var controller = new ScrollMagic.Controller({});

	    // Autoplay and button inits
	    $('.js-sequencedvideo').each(function() {

	        var $el = $(this);
	        var videoplayer = $el.children('video').get(0);
	        var loadedmetadata = false;
	        var timestamps = [];

	        // videoplayer.addEventListener("loadedmetadata", function() {
	        // 	loadedmetadata = true;
	        // }, false);

	        $('.js-timestampbtn').each(function(index, el) {
	        	// Go through each timestamp button and make and object of timestamps
	        	var timestamp = $(this).data('timestamp');
	        	timestamps[index] = timestamp;
	        });


	        videoplayer.ontimeupdate = function() {

	        	var timeStampSlots = timestamps.length;
	        	var currentTime = videoplayer.currentTime;

	        	for (var i = 0; i < timeStampSlots; i++) {

	        		// Deal with the last timestamp
	        		if (i === timeStampSlots-1 ) {

	        			// This is the last timeslot
	        			if ( currentTime >= timestamps[timeStampSlots-1]) {
	        				// If the currentTime is greater than the last timeslot in the object.
	        				activeBtn($el.children('.sequencedvideo__btns').children('button').eq(i).addClass('is-active'));
	        			}

	        		} else {
	        			// If the current time is greater than the current timestamp but is less than the next.
	        			if ( currentTime >= timestamps[i] && currentTime <= timestamps[i+1] ) {
	        				// Remove the active class of previous element.
	        				activeBtn($el.children('.sequencedvideo__btns').children('button').eq(i).addClass('is-active'));
	        			}
	        		}

	        	}
	        };

	        var scene = new ScrollMagic.Scene({
	            triggerHook: 0.95,
	            offset: 100,
	            triggerElement: $el.get(0),
	            reverse: false
	        });

	        scene.on('start', function(e) {
	            if (e.scrollDirection != 'REVERSE') {
	                $el.trigger('autoplay');
	                scene.remove();
	            }
	        });
	        scene.addTo(controller);

	        // Button presses
			$('.js-timestampbtn').on('click', function(event) {
				event.preventDefault();
				// if (loadedmetadata === true) {
					var $btn = $(this);
					activeBtn($btn);
					var timestamp = $btn.data('timestamp');
					playFromTimestamp(timestamp, videoplayer);
				// }

			});


	    });

	    // Trigger the scroll handling
	    $('body').on('autoplay', '.js-sequencedvideo', scrollAutoplayHandler);

	  }
  }
}
/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/components/sequenced-video.js